module.exports = __webpack_public_path__ + "76c9012616b4783fc15019280eccfda9.svg";